export const ACTIONS = {
    clickMore: 'click_more',
    clickChooseTariff: 'click_choose_tariff',
    clickPrivateSector: 'click_private_sector',
    openApplicationForm: 'open_application_form',
};
